import { query } from '@confluence/query-preloader-tools';

import { SPAViewContextQuery } from './SPAViewContextQuery.graphql';

export function preloadSPAViewContext() {
	return query({
		query: SPAViewContextQuery,
	});
}
